import React, { useEffect, useState } from 'react';

import { fetchAllJobs } from '../../api/common';
import Loader from '../../components/Loader';
import { Routes, Route, useParams } from 'react-router-dom';
import OfferPending from './AvailableJobTypes/OfferPending';
import NewJob from './MyApplicationJobTypes/NewJob';
import JobFilter from './AvailableJobTypes/JobFilter';
import Started from './AvailableJobTypes/Started';
import Submitted from './AvailableJobTypes/Submitted';
import InReview from './AvailableJobTypes/InReview';
import OfferAccepted from './AvailableJobTypes/OfferAccepted';
import Expired from './AvailableJobTypes/Expired';
import Closed from './AvailableJobTypes/Closed';
import OfferDeclined from './AvailableJobTypes/OfferDeclined';
export default function AvailableJobsBody({ selected }) {
  const [singleItem, setsingleItem] = useState(null);
  const [loader, setloader] = useState(false);
  let params = useParams();
  const getAllData = async (id) => {
    setloader(true);
    const res = await fetchAllJobs();
    const item = res.find((item) => item.id === +id);
    setsingleItem(item);
    setloader(false);
  };

  const renderTypes = (type = 'filter') => {
    type = type?.toLowerCase();
    switch (type) {
      case 'offer pending':
        return <OfferPending item={singleItem} />;
      case 'new':
        return <NewJob item={singleItem} />;
      case 'jobfilter':
        return <JobFilter item={singleItem} />;
      case 'started':
        return <Started item={singleItem} />;
      case 'submitted':
        return <Submitted item={singleItem} />;
      case 'in review':
        return <InReview item={singleItem} />;
      case 'offer accepted':
        return <OfferAccepted item={singleItem} />;
      case 'expired':
        return <Expired item={singleItem} />;
      case 'closed':
        return <Closed item={singleItem} />;
      case 'offer declined':
        return <OfferDeclined item={singleItem} />;
      default:
        return <JobFilter />;
    }
  };
  useEffect(async () => {
    getAllData(params.id);
  }, [params]);

  return <div>{!loader ? renderTypes(singleItem?.status) : <Loader />}</div>;
}
